import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-668a1610")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Comisión", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-6 p-text-right" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-calendar",
    style: {"font-weight":"bold","padding-right":"10px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Fecha del registro")
], -1)
const _hoisted_7 = { class: "p-col-12 p-text-right" }
const _hoisted_8 = { class: "text " }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col-fixed" }
const _hoisted_12 = {
  style: {"padding-left":"10px"},
  class: "text"
}
const _hoisted_13 = { class: "p-col-12" }
const _hoisted_14 = { class: "p-col-6" }
const _hoisted_15 = { class: "p-grid" }
const _hoisted_16 = { class: "p-col-12" }
const _hoisted_17 = { class: "p-grid" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Seleccionar tag ", -1)
const _hoisted_19 = { class: "p-col-12" }
const _hoisted_20 = { style: {"padding-left":"10px"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Seleccionar Acción ", -1)
const _hoisted_22 = { class: "p-col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Seleccionar Estado ", -1)
const _hoisted_24 = { class: "p-col-12" }
const _hoisted_25 = { class: "p-col-6" }
const _hoisted_26 = { class: "p-grid" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Comentario ", -1)
const _hoisted_28 = {
  class: "p-col-12",
  style: {"position":"relative"}
}
const _hoisted_29 = { class: "p-col-12" }
const _hoisted_30 = { class: "p-grid p-jc-end" }
const _hoisted_31 = { class: "p-col-fixed" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_33 = { class: "p-col-fixed" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Guardar")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: {"width":"70vw"},
    visible: _ctx.visibleProp,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.visibleProp = $event)),
    modal: true,
    showHeader: false,
    dismissableMask: true,
    onHide: _cache[6] || (_cache[6] = $event => _ctx.$emit('update:visible', false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.endMailSending
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: require('@/assets/icons/book.svg'),
            style: {"font-weight":"bold","padding-right":"10px"},
            alt: ""
          }, null, 8, _hoisted_4),
          _hoisted_5
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(new Date().toLocaleDateString()), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StaffTracing, (info) => {
              return (_openBlock(), _createElementBlock("div", {
                key: info._id
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selected,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected = $event)),
                    disabled: true,
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(info.camadaInfo? `Comisión ${info.camadaInfo.id}` : '--'), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Divider)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StaffTracing, (info) => {
                  return (_openBlock(), _createElementBlock("div", { key: info }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.tracingTags.negative, (tag) => {
                      return (_openBlock(), _createElementBlock("div", { key: tag }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_Checkbox, {
                            value: tag,
                            modelValue: _ctx.SelectedTags,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.SelectedTags = $event))
                          }, null, 8, ["value", "modelValue"]),
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_Tag, {
                              style: {"color":"black"},
                              class: _normalizeClass(['p-tag-red-brain'])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.title), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_MultiSelect, {
                style: {"width":"100%"},
                fullWidth: "",
                modelValue: _ctx.actionsSelected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionsSelected = $event)),
                options: _ctx.actions,
                optionLabel: "option",
                placeholder: "Acción"
              }, null, 8, ["modelValue", "options"])
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_MultiSelect, {
                style: {"width":"100%"},
                fullWidth: "",
                modelValue: _ctx.statesSelected,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.statesSelected = $event)),
                options: _ctx.state,
                optionLabel: "option",
                placeholder: "Estado"
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Textarea, {
                rows: "18",
                style: {"width":"100%","resize":"none"},
                autoResize: false,
                modelValue: _ctx.body,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.body = $event)),
                modelModifiers: { lazy: true }
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                style: {"position":"absolute","bottom":"20px","right":"20px"},
                label: "Adjuntar archivo",
                icon: "pi pi-paperclip",
                iconPos: "left",
                class: "p-button-text"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Button, {
                onClick: _ctx.endMailSending,
                class: "p-button-outlined"
              }, {
                default: _withCtx(() => [
                  _hoisted_32
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Button, { onClick: _ctx.endMailSending }, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}